import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/integrations/supabase/client';
import type { Database } from '@/integrations/supabase/types';

export type ProjectRow = Database['public']['Tables']['projects']['Row'];

export interface UseProjectByIdOptions {
  projectId: string | null | undefined;
  enabled?: boolean;
}

export function useProjectById({ projectId, enabled = true }: UseProjectByIdOptions) {
  return useQuery<ProjectRow | null>({
    queryKey: ['projects', 'detail', projectId ?? null] as const,
    enabled: Boolean(projectId) && enabled,
    queryFn: async () => {
      if (!projectId) return null;
      const { data, error } = await supabase
        .from('projects')
        .select('*')
        .eq('id', projectId)
        .maybeSingle();
      if (error) throw error;
      return (data as ProjectRow | null) ?? null;
    },
    staleTime: 30_000,
  });
}
